import { Language } from 'actions/actionTypes';

export const changeLanguage = (language) => ({ type: Language.CHANGE_LANGUAGE, payload: language });